import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperationLog from "models/audioEditor/sequencerOperationLog/SequencerOperationLog";
import RSVP from "rsvp";

const SequencerOperationDeleteWrapWithMuteLog =  SequencerOperationLog.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperationLog.apply(this, [attributes, options]);

    },

    getOperationName : function(){
        return "Delete Wrap with Mute Node";
    },

    setStartSequencerNodeToWrap : function(startSequencerNodeToWrap){
        this.set("startSequencerNodeToWrap", startSequencerNodeToWrap);
    },

    getStartSequencerNodeToWrap : function(){
        return this.get("startSequencerNodeToWrap");
    },

    setEndSequencerNodeToWrap : function(endSequencerNodeToWrap){
        this.set("endSequencerNodeToWrap", endSequencerNodeToWrap);
    },

    getEndSequencerNodeToWrap : function(){
        return this.get("endSequencerNodeToWrap");
    },

    setStartWrapMuteNode : function(startWrapMuteNode){
        this.set("startWrapMuteNode", startWrapMuteNode);
    },

    getStartWrapMuteNode : function(){
        return this.get("startWrapMuteNode");
    },

    setEndWrapMuteNode : function(endWrapMuteNode){
        this.set("endWrapMuteNode", endWrapMuteNode);
    },

    getEndWrapMuteNode : function(){
        return this.get("endWrapMuteNode");
    },




});

export default SequencerOperationDeleteWrapWithMuteLog;
